import React from 'react';
import GameCard from './GameCard';
import HighlightCard from './HighlightCard';
import PostCard from './PostCard';

const FeedItem = ({ item, onEdit, onDelete, onVideoPress, isOwnContent = false }) => {
  // Determine if the current user owns this content
  const isOwnGame = item.user?.id === window.userStore?.profile?.id;
  const isOwnHighlight = item.user?.id === window.userStore?.profile?.id;
  const isOwnPost = item.user?.id === window.userStore?.profile?.id;

  // Determine content type with fallback logic
  let contentType = item.content_type;
  if (!contentType) {
    if (item.media_url && item.media_type) {
      contentType = 'highlight';
      console.log('🔍 FeedItem: Detected highlight by media properties:', { id: item.id, media_url: item.media_url, media_type: item.media_type });
    } else if (item.content) {
      contentType = 'post';
    } else {
      contentType = 'game';
    }
  }

  // Debug logging for highlights
  if (contentType === 'highlight') {
    console.log('🔍 FeedItem: Rendering highlight:', { id: item.id, title: item.title, media_url: item.media_url });
  }

  // Render the appropriate component based on content type
  switch (contentType) {
    case 'game':
      return (
        <GameCard
          key={`game-${item.id}`}
          game={item}
          onEdit={onEdit}
          onDelete={onDelete}
          isOwnGame={isOwnGame}
        />
      );
    
    case 'highlight':
      return (
        <HighlightCard
          key={`highlight-${item.id}`}
          highlight={item}
          onVideoPress={onVideoPress}
          onEdit={onEdit}
          onDelete={onDelete}
          isOwnHighlight={isOwnHighlight}
        />
      );
    
    case 'post':
      return (
        <PostCard
          key={`post-${item.id}`}
          post={item}
          onEdit={onEdit}
          onDelete={onDelete}
          isOwnPost={isOwnPost}
        />
      );
    
    default:
      // Final fallback: try to infer content type based on item properties
      if (item.media_url && item.media_type) {
        console.log('🔍 FeedItem: Fallback detected highlight:', { id: item.id, media_url: item.media_url, media_type: item.media_type });
        return (
          <HighlightCard
            key={`highlight-${item.id}`}
            highlight={{ ...item, content_type: 'highlight' }}
            onVideoPress={onVideoPress}
            onEdit={onEdit}
            onDelete={onDelete}
            isOwnHighlight={isOwnHighlight}
          />
        );
      } else if (item.content) {
        return (
          <PostCard
            key={`post-${item.id}`}
            post={{ ...item, content_type: 'post' }}
            onEdit={onEdit}
            onDelete={onDelete}
            isOwnPost={isOwnPost}
          />
        );
      } else {
        return (
          <GameCard
            key={`game-${item.id}`}
            game={{ ...item, content_type: 'game' }}
            onEdit={onEdit}
            onDelete={onDelete}
            isOwnGame={isOwnGame}
          />
        );
      }
  }
};

export default FeedItem; 